import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  isMakeCopyForBrandModalShown: false,
  action: undefined,
};

function onShowMakeCopyForBrandModal(state, { payload }) {
  return {
    ...state,
    isMakeCopyForBrandModalShown: true,
    action: payload,
  };
}

function onCloseMakeCopyForBrandModal(state) {
  return {
    ...state,
    isMakeCopyForBrandModalShown: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.SHOW_MAKE_COPY_FOR_BRAND_MODAL]: onShowMakeCopyForBrandModal,
  [actions.CLOSE_MAKE_COPY_FOR_BRAND_MODAL]: onCloseMakeCopyForBrandModal,
  [actions.CLEAR_STORE]: onClearStore,
});
